import * as actions from './actions';
import * as getters from './getters';
import { FETCH_UPCOMING_EVENTS } from '../../mutation-types';

const mutations = {
  [FETCH_UPCOMING_EVENTS](state, payload) {
    state.upcomingEvents = payload
  },
};

const state = {
  upcomingEvents: null,
  url: '/v1/events'
};

export default {
  namespaced: true,
  mutations,
  actions,
  getters,
  state,
};


